export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'https://api.blueplanitservices.com/prod';
// export const SERVER_URL = 'http://13.57.151.230:5001';
// export const SERVER_URL = 'http://localhost:5001';
export const S3ACCESSURL = `${SERVER_URL}/api/proxy?url=`

// The "Cancelled" request status needs backend support (summary.cancelled on
// getAllOrders, cancelledRequests/totalRequestsCancelled on
// getOperationsDashboard). GraphQL rejects the ENTIRE query with HTTP 400 if a
// selected field is missing from the schema, so requesting these against a
// backend that hasn't been deployed yet breaks the Requests grid and the
// Operations dashboard outright.
//
// Flip to true in the SAME deploy that ships the backend changes above.
// Until then the UI still renders every Cancelled control — the counts simply
// read 0, which is what an undeployed backend can actually tell us.
export const BACKEND_HAS_CANCELLED_STATUS = false;

// Default stage filter for the Requests list. "Active" is a COMPOSITE the
// backend expands to Open + In Progress + On Hold (see ACTIVE_REQUEST_STATUSES
// in Backend/GraphQL/Queries/getAllOrders.js) — defaulting to "Open" alone hid
// every In Progress and On Hold request from the landing view.
// The matching dropdown option is seeded by
// Backend/migrations/addActiveRequestFilterOption.js.
// "Active" is a COMPOSITE the backend expands to Open + In Progress + On Hold.
// The PRODUCTION backend (databucket's SERVER_URL above) does a plain exact
// match on requestStatus, so sending "Active" there matches NOTHING and the
// grid silently shows "No data" — worse than an error, because nothing tells
// you why. Same deploy-ordering rule as BACKEND_HAS_CANCELLED_STATUS.
//
// Flip to true in the SAME deploy that ships getAllOrders' ACTIVE_FILTER branch.
export const BACKEND_HAS_ACTIVE_FILTER = false;

// Landing filter for the Requests list. Falls back to "Open" — a real stored
// status every backend understands — until the composite is deployed.
export const DEFAULT_REQUEST_FILTER = BACKEND_HAS_ACTIVE_FILTER ? 'Active' : 'Open';

export const REQUEST_TYPE = ['New', 'Revision', 'Resend'];
export const DEPARTMENT = ['Personal Line', 'Commercial Lines']
export const POLICY_TYPE_PERSONAL = ['Home Owners(HO3)', 'Renters(HO4)', 'Condo(HO6)', 'Dwelling Fire(DP3)', 'Home Owners(HO5)', 'Motor Cycle', ' Vehicle', 'Boat', 'Personal Auto', 'Builders Risk', 'Personal Umbrella'];
export const POLICY_TYPE_COMMERCIAL = ['BOP', 'Business Interruption', 'Commercial General Liability', 'Commercial Property', 'Commercial Umbrella', 'Commercial Auto', 'Workers Compensation', 'Inland Marine', 'Commercial Package'];
export const CURRENT_CARRIERS = ['Aegis Security Ins', 'AIG', 'American Modern', 'AmTrust', 'AmWINS (formally Networked)', 'Assurant Flood', 'Auto Owners', 'Allied - Nationwide', 'Allstate', 'Arrowhead', 'Berkley One', 'Bristol West', 'CATcoverage.com', 'Chubb', 'Citizens', 'CNA', 'Donegal Insurance Companies', 'Encompass', 'First Connection', 'Foremost Business', 'Foremost Star', 'Foremost Star- Me', 'Foremost/Bristol', 'Grange', 'Guard', 'Hanover', 'Hagerty', 'Haulers', 'Hippo', 'Liberty Mutual', 'Lamonade', 'Kemper', 'Main Street America Group Carrie logins', 'Main Street America Group', 'Mercury', 'Nationwide', 'NBS Agent Login', 'Openly', 'Personal Umbrella', 'Pinnacol', 'Private Client NW/Crestbrook', 'Progressive', 'PURE', 'Safeco', 'State Auto', 'Stillwater', 'Travelers', 'Trexis', 'USLI', 'National General', 'Westfield Insurance', 'The Hartford']
export const REQUEST_PRIORITY = ['Rush', 'On Demand', 'Bulk'];
export const PROCESS_TYPE = ['Audits', 'BORs', 'Cancellations', 'Certificate Issurance', 'DBRs', 'Endorsements', 'Loss Runs', 'LPRs', 'PFAs', 'Policy Checking', 'Policy Quoting', 'Policy Renewals', 'Proposals', 'Special Projects', 'Supplemental', 'MVRs', 'EOP Template', 'Pre-Renewal Letters', 'Auto ID Cards', 'Invoicing', 'Direct Bill Reconciliation', 'New Account Creation', 'Renewals Processing', 'Billing'];
export const REQUEST_STATUS = ['Open', 'In Progress', 'On Hold', 'Completed'];
export const REQUEST_STAGE = ['Open', 'In Progress', 'On Hold', 'Completed'];
export const REQUEST_FILTER_STAGE = ['Open', 'In Progress', 'On Hold', 'Completed', 'All'];
export const START_BUTTON_TASKS = ['Processing', 'Email', 'Quality', 'Management']
export const DEPARTMENTS = ['Sales', 'Operations', 'IT'];

export const STATUS = [
  { label: "Active", value: "Active" },
  { label: "InActive", value: "InActive" }
]

export const PROCESS_SPECIALIZATION = [
  { label: 'Accords', value: 'Accords' },
  { label: 'Audits', value: 'Audits' },
  { label: 'BORs', value: 'BORs' },
  { label: 'Cancellations', value: 'Cancellations' },
  { label: 'Certificate Issuance', value: 'Certificate Issuance' },
  { label: 'DBRs', value: 'DBRs' },
  { label: 'Endorsements', value: 'Endorsements' },
  { label: 'Loss Runs', value: 'Loss Runs' },
  { label: 'LPRs', value: 'LPRs' },
  { label: 'PFAs', value: 'PFAs' },
  { label: 'Policy Checking', value: 'Policy Checking' },
  { label: 'Policy Quoting', value: 'Policy Quoting' },
  { label: 'Policy Renewals', value: 'Policy Renewals' },
  { label: 'Proposals', value: 'Proposals' },
  { label: 'Special Projects', value: 'Special Projects' },
  { label: 'Supplemental', value: 'Supplemental' },
  { label: 'MVRs', value: 'MVRs' },
  { label: 'EOP Template', value: 'EOP Template' },
  { label: 'Pre-Renewal Letters', value: 'Pre-Renewal Letters' },
  { label: 'Auto ID Cards', value: 'Auto ID Cards' },
  { label: 'Invoicing', value: 'Invoicing' },
  { label: 'Direct Bill Reconciliation', value: 'Direct Bill Reconciliation' },
  { label: 'New Account Creation', value: 'New Account Creation' },
  { label: 'Renewals Processing', value: 'Renewals Processing' }
];
export const BUSINESS_DEVELOPMENT_EXECUTIVE = [
  { label: "Senior", value: "Senior" },
  { label: "Junior", value: "Junior" }
]
export const TECHNICAL_SPECIALIZATION = [
  { label: "Senior Developer", value: "Senior Developer" },
  { label: "Junior Developer", value: "Junior Developer" }
]
export const OPERATION_DESIGNATION = [
  { label: "Process Executive", value: "Process Executive" },
  { label: "Asst.Account Executive", value: "Asst.Account Executive" }
];
export const SALES_DESIGNATION = [
  { label: "Sales Executive", value: "Sales Executive" },
  { label: "Sales Manager", value: "Sales Manager" }
]
export const IT_DESIGNATION = [
  { label: "Jr.Developer", value: "Jr.Developer" },
  { label: "Sr.Developer", value: "Sr.Developer" }
]
export const SHIFT_TIMINGS = [{ label: "9am-5pm", value: "9am-5pm" }]
export const TIMER_DEPARTMENT = [
  { label: 'Operations', value: 'Operations' },
  { label: 'Sales', value: 'Sales' },
  { label: 'IT', value: 'IT' },
];

export const DATA_BUCKET_DEPARTMENT = [
  { label: 'Employees', value: 'Employees' },
  { label: 'Employee Leaves', value: 'Employee Leaves' },
  { label: 'Clients', value: 'Clients' },
  { label: 'Sales', value: 'Sales' },
  { label: 'Requests', value: 'Requests' },
  { label: 'Routes', value: 'Routes' }
];

export const ACTIVE_STATUS2 = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
]
export const USER_TYPE = [
  { label: 'User', value: 'User' },
  { label: 'Admin', value: 'Admin' },
  { label: 'Super Admin', value: 'Super Admin' },
];
export const Rehire = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" }
];


export const TYPES_OF_LEAVES = [
  { value: "Sick Leave ", label: "Sick Leave" },
  { value: "Casual Leave", label: "Casual Leave" },
  { value: "Paid Leave", label: "Paid Leave" },
];

export const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export const WORK_TYPE = [
  { value: "WFH", label: "Work From Home (WFH)" },
  { value: "WFO", label: "Work From Office (WFO)" },
  { value: "Hybrid", label: "Hybrid" },
];


export const TIMER_TASKS = ['Available', 'Break', 'Meeting', 'Admin', 'Management', 'Training', 'Cross-Training', 'No-work Assigned']

export const bloodGroups = [
  { value: "A+", label: "A+" },
  { value: "A-", label: "A-" },
  { value: "B+", label: "B+" },
  { value: "B-", label: "B-" },
  { value: "AB+", label: "AB+" },
  { value: "AB-", label: "AB-" },
  { value: "O+", label: "O+" },
  { value: "O-", label: "O-" }
];
export const EDUCATION_LEVEL = [
  { label: "10th", value: "10th" },
  { label: "12th", value: "12th" },
  { label: "Diploma", value: "Diploma" },
  { label: "Under Graduation", value: "Under Graduation" },
  { label: "Post Graduation", value: "Post Graduation" },
  { label: "PhD", value: "PhD" },
  { label: "M.Phil", value: "M.Phil" },
  { label: "Certificate Course", value: "Certificate Course" },
  { label: "Vocational Training", value: "Vocational Training" },
  { label: "Others", value: "Others" }
];

export const SIDEMENU = [
  {
    mainId: 100000,
    name: "Employees",
    status: false,
    Subfields: [
      { subId: 10000101, displayName: "Employee", name: "/employees", status: false },
      { subId: 10000102, displayName: "My Leaves", name: "/employee-leaves", status: false },
      { subId: 10000103, displayName: "Leave Applications", name: "/adminleaves", status: false },
      { subId: 10000104, displayName: "Leave Settings", name: "/leave-settings", status: false },
      { subId: 10000105, displayName: "My Attendance", name: "/employeeattendance", status: false },
      { subId: 10000106, displayName: "Employee Attendance", name: "/adminattendance", status: false },
      { subId: 10000107, displayName: "Holidays", name: "/holidays", status: false },
      { subId: 10000109, displayName: "Reset Token", name: "/reset-token", status: false },
      { subId: 10000110, displayName: "ID Card", name: "/IdCard", status: false },
      // { subId: 10000111, displayName: "Emails", name: "/emails", status: false },
      // { subId: 10000112, displayName: "Shared Emails", name: "/AddSharedEmails", status: false },
      { subId: 10000112, displayName: "Mails", name: "/emails", status: false },
      // { subId: 10000113, displayName: "Manual-Invoice", name: "/Manual-Invoice", status: false },
      { subId: 10000113, displayName: "My Handbooks", name: "/my-handbooks", status: false },
      { subId: 10000114, displayName: "Announcements", name: "/announcements", status: false },
      { subId: 10000115, displayName: "My Payslip", name: "/my-payslip", status: false },
    ],
  },
  {
    mainId: 100001,
    name: "Clients",
    status: false,
    Subfields: [
      { subId: 10000201, displayName: "Clients", name: "/clients", status: false },
      { subId: 10000202, displayName: "Client Mails", name: "/ClientMails", status: false },
      { subId: 10000203, displayName: "Invoices", name: "/All-Invoices", status: false },
       { subId: 10000204, displayName: "Manual-Invoice", name: "/Manual-Invoice", status: false },
    ],
  },
  {
    mainId: 100002,
    name: "Sales",
    status: false,
    Subfields: [
      // { subId: 10000301, displayName: "Sales", name: "/sales", status: false },
      { subId: 10000301, displayName: "Leads", name: "/sales", status: false },
      { subId: 10000302, displayName: "Pipeline", name: "/Pipeline", status: false },
      { subId: 10000303, displayName: "BD Playbook", name: "/playbook", status: false },
      { subId: 10000304, displayName: "Email History", name: "/email-history", status: false },
      { subId: 10000305, displayName: "Email Templates", name: "/email-templates", status: false },
      { subId: 10000306, displayName: "Verification History", name: "EmailVerificationHistory", status: false },
      { subId: 10000307, displayName: "Lead Analytics", name: "/LeadAnalytics", status: false },
      { subId: 10000308, displayName: "Unsubscribe History", name: "/UnsubscribeHistory", status: false },
      { subId: 10000309, displayName: "Bulk Outreach", name: "/bulk-outreach", status: false },
      { subId: 10000310, displayName: "Manual Reports", name: "/sales/manual-reports", status: false },
      { subId: 10000311, displayName: "Team Reports", name: "/sales/manual-reports/team", status: false },
    ],
  },
  {
    mainId: 100003,
    name: "Requests",
    status: false,
    Subfields: [
      { subId: 10000401, displayName: "Requests", name: "/request", status: false },
    ],
  },
  {
    mainId: 100005,
    name: "Time Records",
    status: false,
    Subfields: [
      { subId: 10000601, displayName: "My Record", name: "/EmployeeReport", status: false },
      { subId: 10000602, displayName: "Operations Record", name: "/ClientReport", status: false },
      { subId: 10000603, displayName: "Sales Record", name: "/SalesReport", status: false },
    ],
  },
  {
    mainId: 100011,
    name: "Reports",
    status: false,
    Subfields: [
      { subId: 10001201, displayName: "Client Reports", name: "/RecordClientReport", status: false },
      { subId: 10001202, displayName: "Employee Reports", name: "/RecordEmployeeReport", status: false },
      { subId: 10001203, displayName: "Time Record Log", name: "/RecordTimeLog", status: false },
      { subId: 10001204, displayName: "Client Billing Report", name: "/ClientBillingReport", status: false },
      { subId: 10001205, displayName: "Employee Performance", name: "/EmployeePerformanceReport", status: false },
      { subId: 10001206, displayName: "Operations Dashboard", name: "/OperationsDashboard", status: false },
      { subId: 10001207, displayName: "My Dashboard", name: "/MyDashboard", status: false },
      { subId: 10001208, displayName: "Sales Dashboard", name: "/SalesDashboard", status: false },
    ],
  },
  {
    mainId: 100007,
    name: "Data Bucket",
    status: false,
    Subfields: [
      { subId: 10000801, displayName: "Data Bucket", name: "/dataBucket", status: false },
      { subId: 10000802, displayName: "Dropdown Manager", name: "/dropdownManager", status: false },
    ],
  },
  {
    mainId: 100009,
    name: "Dashboard",
    status: false,
    Subfields: [
      { subId: 10001001, displayName: "Dashboard", name: "/Dashboard", status: false },
      { subId: 10001002, displayName: "Sales Stats", name: "/SalesStats", status: false },
      { subId: 10001003, displayName: "Request Stats", name: "/RequestStats", status: false },
    ],
  },
  {
    mainId: 100010,
    name: "Dynamic Route",
    status: false,
    Subfields: [
      { subId: 10001101, displayName: "Dynamic Route", name: "/DynamicRoute", status: false },
    ],
  },
  {
    mainId: 100014,
    name: "Tasks",
    status: false,
    Subfields: [
      { subId: 10001115, displayName: "List of Tasks", name: "Tasks/ViewTasks", status: false },
      { subId: 10001107, displayName: "User Tasks", name: "Tasks/MyTasks", status: false },
    ],
  },
  {
    mainId: 100017,
    name: "Email Validation",
    status: false,
    Subfields: [
      { subId: 10001110, displayName: "Email Validation", name: "EmailValidation", status: false },
    ],
  },
  /* Bulk Emails (Brevo) removed from SIDEMENU — replaced by Bulk Outreach under Sales */
  {
    mainId: 100019,
    name: "Ring Central",
    status: false,
    Subfields: [
      { subId: 10001114, displayName: "RingCentral", name: "/ringcentral", status: false },
    ],
  },
  {
    mainId: 100019,
    name: 'Outlook',
    status: false,
    Subfields: [
      { subId: 10001113, displayName: "Personal Outlook", name: "/personalOutlook", status: false },
      { subId: 10001119, displayName: "Outlook", name: "/Outlook", status: false },
      { subId: 10001120, displayName: "Sales Outlook", name: "/salesOutlook", status: false },
      { subId: 10001121, displayName: "Outlook 2.0", name: "/OutlookNew", status: false }
    ],

    __typename: "SideMainType",
  },
  {
    mainId: 100020,
    name: 'Finance',
    status: false,
    Subfields: [
      { subId: 10001114, displayName: "Finance", name: "/Finance", status: false },
    ],
  },
  {
    mainId: 100021,
    name: 'Assets',
    status: false,
    Subfields: [
      { subId: 10001117, displayName: "Assets", name: "/ListOfAssets", status: false },
      { subId: 10001118, displayName: "Maintenance", name: "/ListOfMaintenances", status: false },
      { subId: 10001119, displayName: "Warranties", name: "/ListOfWarranties", status: false },
      { subId: 10001119, displayName: "Tools", name: "/AssetTool", status: false }
    ],
  },
  {
    mainId: 100022,
    name: "Brochure",
    status: false,
    Subfields: [
      { subId: 10001121, displayName: "Fileupload", name: "/Brochure/Fileupload", status: false },
      { subId: 10001122, displayName: "Emails", name: "/Brochure/emails", status: false }
    ],
  },
  {
    mainId: 100023,
    name: "Access Keys",
    status: false,
    Subfields: [
      { subId: 10001123, displayName: "Access Keys", name: "/AccessKeys", status: false },
    ],
  },
  {
    mainId: 100024,
    name: "Biometric Attendance",
    status: false,
    Subfields: [
      { subId: 10001127, displayName: "Reports", name: "/BiometricAttendance/Reports", status: false },

    ],
  },
  {
    mainId: 100025,
    name: "Hiring",
    status: false,
    Subfields: [
      { subId: 10001128, displayName: "Job Requisition", name: "/JobRequisition", status: false },
      { subId: 10001129, displayName: "Review & Publish", name: "/JobPosting", status: false },
      { subId: 10001130, displayName: "Candidate Management", name: "/CandidateList", status: false },
      { subId: 10001131, displayName: "InterView Screening", name: "/InterviewScheduling", status: false },
      { subId: 10001132, displayName: "Offer Management", name: "/OfferManagement", status: false },

    ],
  },
  {
    mainId: 100026,
    name: "Access Management",
    status: false,
    Subfields: [
      { subId: 10001133, displayName: "Route Management", name: "/RouteAccess", status: false },
      { subId: 10001133, displayName: "Employee Management", name: "/EmployeeAccess", status: false },
      { subId: 10001134, displayName: "Client Data Management", name: "/client-access", status: false },
      { subId: 10001135, displayName: "Device Management", name: "/device-access", status: false },
      { subId: 10001136, displayName: "Handbook Management", name: "/handbook-access", status: false },
      { subId: 10001137, displayName: "Personal Outlook Access", name: "/personal-outlook-access", status: false },
      { subId: 10001138, displayName: "Client Outlook Access", name: "/client-outlook-access", status: false },
      { subId: 10001139, displayName: "Sales Outlook Access", name: "/sales-outlook-access", status: false },
      { subId: 10001140, displayName: "Mobile Route Management", name: "/mobile-route-access", status: false },
      { subId: 10001141, displayName: "Client Logins", name: "/client-logins", status: false },
      { subId: 10001143, displayName: "Access Slots", name: "/access-slots", status: false },
    ],
  },
  {
    mainId: 100027,
    name: 'Activity',
    status: false,
    Subfields: [
      { subId: 10001133, displayName: "Activity", name: "/activity", status: false }
    ]
  },
  {
    mainId: 100028,
    name: 'Payroll',
    status: false,
    Subfields: [
      { subId: 10001300, displayName: "Payroll", name: "/payroll", status: false }
    ]
  },
  {
    mainId: 100029,
    name: 'WhatsApp',
    status: false,
    Subfields: [
      { subId: 10001400, displayName: "WhatsApp Inbox", name: "/whatsapp", status: false },
      { subId: 10001401, displayName: "WhatsApp Admin", name: "/whatsapp-admin", status: false },
    ]
  },

];

// export const NEXT_FIELD = ["CTC",'Basic', 'House Rent Allowance', 'Medical Allowance','Special Allowance','Incentives','Night Shift Allowance','Conveyance Allowance','CTC Canteen','CTC Health Insurance','PF Employee Contribution','PF Employer'];
export const NEXT_FIELD = [
  { label: "CTC", value: "CTC" },
  { label: "Basic", value: "Basic" },
  { label: "House Rent Allowance", value: "House Rent Allowance" },
  { label: "Medical Allowance", value: "Medical Allowance" },
  { label: "Special Allowance", value: "Special Allowance" },
  { label: "Incentives", value: "Incentives" },
  { label: "Night Shift Allowance", value: "Night Shift Allowance" },
  { label: "Conveyance Allowance", value: "Conveyance Allowance" },
  { label: "CTC Canteen", value: "CTC Canteen" },
  { label: "CTC Health Insurance", value: "CTC Health Insurance" },
  { label: "PF Employee Contribution", value: "PF Employee Contribution" },
  { label: "PF Employer", value: "PF Employer" }
];

export const INSURANCE_CARRIERS = ['Aegis Security Ins', 'AIG', 'American Modern', 'AmTrust', 'AmWINS (formally Networked)', 'Assurant Flood', 'Auto Owners', 'Allied - Nationwide', 'Allstate', 'Arrowhead', 'Berkley One', 'Bristol West', 'CATcoverage.com', 'Chubb', 'Citizens', 'CNA', 'Donegal Insurance Companies', 'Encompass', 'First Connection', 'Foremost Business', 'Foremost Star', 'Foremost Star- Me', 'Foremost/Bristol', 'Grange', 'Guard', 'Hanover', 'Hagerty', 'Haulers', 'Hippo', 'Liberty Mutual', 'Lamonade', 'Kemper', 'Main Street America Group Carrie logins', 'Main Street America Group', 'Mercury', 'Nationwide', 'NBS Agent Login', 'Openly', 'Personal Umbrella', 'Pinnacol', 'Private Client NW/Crestbrook', 'Progressive', 'PURE', 'Safeco', 'State Auto', 'Stillwater', 'Travelers', 'Trexis', 'USLI', 'National General', 'Westfield Insurance', 'The Hartford']
export const PRIORITY = ['High', 'Medium', 'Low'];
export const RESIGNATION_STATUS = ['Yes', 'No'];
export const EMPLOYMENT_STATUS = ['Yes', 'No'];
export const SALES_STATUS = ['New', 'Open', 'On Hold', 'In Progress', 'Reopened', 'Closed'];
export const LEAD_STAGE = ['Sales team', 'Operation team', 'Closing team', 'Data team'];
export const LEAD_CHANNEL = ['Cold Calling', 'Email', 'LinkedIn', 'Reference'];
export const TIMEZONE = ['Eastern Time', 'Central Time', 'Mountain Time', 'Pacific Time', 'Hawaii Time'];

export const CALL_STATUS = ['Attempt', 'Call Back', 'Call-in Future', 'Contacted', 'Follow-up', 'Front-Desk', 'Qualified', 'Unqualified'];
export const EMAIL_STATUS = ['Sent', 'Delivered', 'Client Read', 'undelivered', 'Wrong email', 'Response received', 'Not interested'];
export const LINKEDIN_STATUS = ['Request Sent', 'Accepted', 'Communicated', 'Not-accepted'];
export const SCHEDULED_CALL_TYPE = ['Phone Call', 'Zoom Call'];

// RequestForm
export const Quote_Type = 'QuoteType'
export const Department = 'Department'
export const Insured_Name = 'InsuredName'
export const Number_of_Quotes = 'NoofQuotes'
export const Radio_Value = 'RadioValue'

//-------------
export const ExistingPolicyInformation = 'ExistingPolicyInformation'
//-------------
export const Current_Carrier = 'Current_Carrier'
export const Property_Type = 'Property_Type'
export const Property_New = 'Property_New'
export const Policy_Number = 'Policy_Number'
export const Effective_Date = 'Effective_Date'
export const Current_Premium = 'Current_Premium'

//-------------
export const NewQuoteInformation = 'NewQuoteInformation'
//-------------
export const Policy = 'Policy'
export const Insurance_Carrier = 'Insurance_Carrier'
export const Quoted_Premium = 'Quoted_Premium'

//Request Information----------------------------------------
export const Priority = 'Priority'
export const ProcessType = 'ProcessType'
export const AssignedTo = 'AssignedTo'
export const AssignTo = 'AssignTo'
export const StartDate = 'StartDate'
export const DueDate = 'DueDate'
export const RequestStatus = 'RequestStatus'
export const RadioInfo = 'RadioInfo'
export const EmailSummary = 'EmailSummary'
export const Requestor = 'Requestor'
export const SendTo = 'SendTo'


export const COMPANY_NAME_CONFIG = ['Blueplanit', 'The DeLuca Agency', 'BTJ Insurance, Inc', 'Heidi Kussurelis Agency', 'CharSan Insurance & Consulting LLC', 'Jain Insurance Agency', 'Lincoln Insurance Group, LLC', 'Scott Held Insurance Agency', 'Laurie Insurance Group LLC', 'Aloha Insurance Services, Inc', 'SJL Insurance Service, Inc']
export const DEPARTMENT_CONFIG_CLIENT = ['Personal Line', 'Commercial Lines', "Both"];

export const FINANCE_CATEGORY = ['YES', 'NO'];
export const FINANCE_SUB_CATEGORY = ['YES', 'NO'];
export const TRANSACTION_MODE = ['Cash', 'Card'];

// -----
export const ACTIVE_STATUS = ['Active', 'Inactive'];

//Assets
export const ASSET_CATEGORY = ['YES', 'NO'];



//Request Work History
export const DEPARTMENTS_ASSIGNED = ['Personal Line', 'Commercial Lines', "Both"];
export const SERVICES_ASSIGNED = ['Audits', 'BORs', 'Cancellations', 'Certificate Issuance', 'DBRs', 'Endorsements', 'Loss Runs', 'LPRs', 'PFAs', 'Policy Checking', 'Policy Quoting', 'Policy Renewals', 'Proposals', 'Special Projects', 'Supplemental', 'MVRs', 'EOP Template', 'Pre-Renewal Letters', 'Auto ID Cards', 'Invoicing', 'Direct Bill Reconciliation', 'New Account Creation', 'Renewals Processing', 'Billing'];

// Clears ALL local state on session end. On a SHARED office machine, nothing from
// one user's session may survive into the next user's. We intentionally do NOT
// preserve any keys here: previously email read/flag/pin state (which is not
// user-scoped) was kept across logout/token-expiry, which leaked one user's email
// activity to the next user on the same PC. Outlook read status re-syncs from the
// server (MS Graph) on the next login, so nothing important is lost.
export function clearLocalStorageSafe() {
  try { localStorage.clear(); } catch { /* storage unavailable */ }
}

// Hard logout: wipe ALL local state and force a full reload to the login screen.
// A soft route change ("/") leaves the Redux store and the Apollo InMemoryCache
// intact in memory — both hold sensitive data (leads, clients, finance, emails).
// A real reload destroys the whole JS runtime, so the next user on a shared
// machine starts from a clean slate. This is the ONLY safe way to end a session
// on a shared computer.
export function hardLogoutReload() {
  try { localStorage.clear(); } catch { /* ignore */ }
  try { sessionStorage.clear(); } catch { /* ignore */ }
  // Send HashRouter (Desktop) straight to the login route; BrowserRouter (web)
  // ignores the hash and its auth guard redirects to login after the reload.
  try { window.location.hash = "#/"; } catch { /* ignore */ }
  // The reload is what destroys the Redux store and Apollo cache. reload() works
  // in EVERY environment — web http(s), Electron dev (http), and the packaged
  // Electron app (file://) — unlike navigating to "/", which would point at the
  // filesystem root under file://.
  window.location.reload();
}
